// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'star-mixed';

export const Component = () => (
  <path d='m16.613 7.898 7.519 1.197c.288.096.431.24.431.48a.434.434 0 0 1-.191.382l-5.7 5.077 1.533 7.95v.096c0 .335-.143.479-.478.479-.144 0-.192 0-.24-.048l-6.753-3.496L6.03 23.51c-.048.048-.096.048-.24.048-.335 0-.478-.144-.478-.48v-.095l1.58-7.95-5.747-5.077a.542.542 0 0 1-.143-.383c0-.239.143-.383.43-.479l7.52-1.197 3.4-6.657c.048-.144.192-.24.432-.24.191 0 .335.097.43.288l3.4 6.61-.002-.001Zm.957 6.8.432-.382 4.932-4.407-6.992-1.149-3.16-6.178-2.97 5.747-.24.431L2.58 9.91l5.365 4.788L6.46 22.17l6.274-3.258 6.275 3.258-1.437-7.472h-.002ZM12.78 1.001v19.06l-.047-.047-6.705 3.496H5.98c0 .048 0 .048-.047.048h-.144c-.335 0-.479-.144-.479-.48v-.095l1.58-7.95-5.746-5.077A.542.542 0 0 1 1 9.573c0-.239.144-.382.431-.478l7.52-1.198 3.4-6.61c.047-.143.191-.239.431-.287h-.002Z' />
);

export const viewBox = '0 0 25 25';
